import React from "react";

const BrandSvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clip-path="url(#clip0_11359_77962)">
        <g id="Group">
          <path
            id="Vector"
            d="M4.48218 5.60742H7.53739V6.8902H4.48218V5.60742ZM4.48218 8.52439H7.53739V9.80717H4.48218V8.52439ZM4.48218 11.4413H7.53739V12.7241H4.48218V11.4413ZM4.48218 14.3583H7.53739V15.6411H4.48218V14.3583Z"
            fill="#006CDD"
          />
          <path
            id="Vector_2"
            d="M10.6607 17.3494V6.86787L17.359 6.86005V13.9309H18.641V6.21791C18.641 5.868 18.3487 5.5765 17.9992 5.5765L10.0189 5.58582C9.66517 5.58625 9.37863 5.87325 9.37863 6.22723V17.3494H2.64103V4.65723L9.37863 2.84471V4.3009H10.6607V2.00808C10.6607 1.59313 10.2542 1.28082 9.85321 1.38868L1.83355 3.54607C1.69734 3.58276 1.57702 3.66333 1.49123 3.7753C1.40544 3.88728 1.35895 4.02441 1.35897 4.16548V17.3494H0V18.6321H20V17.3494H10.6607Z"
            fill="#006CDD"
          />
          <path
            id="Vector_3"
            d="M17.3591 15.0853H18.6411V16.2802H17.3591V15.0853ZM12.4626 8.52441H15.5179V9.80719H12.4626V8.52441ZM12.4626 11.4413H15.5179V12.7241H12.4626V11.4413ZM12.4626 14.3583H15.5179V15.6411H12.4626V14.3583Z"
            fill="#006CDD"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11359_77962">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BrandSvg;
